import { createReducer, on } from '@ngrx/store';
import { ContentPage } from '../../models';
import * as pageActions from '../actions/content-pages.action';
import * as utility from '../../../utility';

export interface ContentPagesState {
  entities: { [slug: string]: ContentPage };
  loaded: string[];
  loading: string[];
  overviewLoaded: boolean;
  overviewLoading: boolean;
  error?: any;
}

export const initialState: ContentPagesState = {
  entities: {},
  loaded: [],
  loading: [],
  overviewLoaded: false,
  overviewLoading: false,
};

export const contentPageReducer = createReducer(
  initialState,
  on(pageActions.LoadContentPages, (state: ContentPagesState) => {
    return {
      ...state,
      overviewLoading: true,
      error: null,
    };
  }),
  on(pageActions.LoadContentPagesSuccess, (state: ContentPagesState, { contentPages }) => {
    const entities = utility.ToEntities(contentPages, 'slug', state.entities);
    return {
      ...state,
      entities,
      overviewLoading: false,
      overviewLoaded: true,
      error: null,
    };
  }),
  on(pageActions.LoadContentPagesFail, (state: ContentPagesState, { error }) => {
    return {
      ...state,
      overviewLoading: false,
      overviewLoaded: false,
      error,
    };
  }),
  on(pageActions.LoadContentPageBySlug, (state: ContentPagesState, { slug }) => {
    return {
      ...state,
      loading: [...state.loading, slug],
      error: null,
    };
  }),
  on(pageActions.LoadContentPageBySlugSuccess, (state: ContentPagesState, { page, slug }) => {
    const entities = { ...state.entities, [slug]: page };
    return {
      ...state,
      entities,
      loading: state.loading.filter(s => s !== slug),
      loaded: [...state.loaded, slug],
      error: null,
    };
  }),
  on(pageActions.LoadContentPageBySlugFail, (state: ContentPagesState, { error, slug }) => {
    return {
      ...state,
      loading: state.loading.filter(s => s !== slug),
      loaded: state.loaded.filter(s => s !== slug),
      error,
    };
  })
);

export const getContentPagesEntities = (state: ContentPagesState) => state.entities;
export const getContentPagesLoading = (state: ContentPagesState) => state.loading;
export const getContentPagesLoaded = (state: ContentPagesState) => state.loaded;
export const getContentPagesError = (state: ContentPagesState) => state.error;
export const getContentPagesOverviewLoading = (state: ContentPagesState) => state.overviewLoading;
export const getContentPagesOverviewLoaded = (state: ContentPagesState) => state.overviewLoaded;
